/**
 *  © 2025 -2026 DXC Technology,  all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Modal from '../Common/Modal';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import ImageFallback from '../Common/ImageFallback';
import MU from '../../constants/muConstants';
import { createDestinationUrl } from '../../utils/utils';
import Helmet from 'react-helmet';
import { gapiLoaded, gisLoaded, handleAuthClick } from '../../utils/calendarUtils';
const CalenderModal = (props) => {
  const {
    closeModal,
    AddToCalendarButtons,
    calendarHeadline,
    calendarTitle,
    fixtureCalendarHeadline,
    calendarDescription,
    noteHeadline,
    noteDescription,
    appleShortAddtoCalendar,
    googleShortAddtoCalendar,
    outlookShortAddtoCalendar,
    descriptionText,
    Title,
    startdatetime_tdt,
    enddatetime_tdt,
    configData,
    isConfigInst,
    isFixtureCard,
  } = props;

  const eventCalender = MU?.eventCalendar;
  const appleTittle = eventCalender?.appleTitle;
  const appleAddtoCalendar = eventCalender?.appleAddtoCalendar;
  const appleImage = eventCalender?.appleImage;
  const enableAppleCalendar = eventCalender?.enableAppleCalendar;
  const googleTitle = eventCalender?.googleTitle;
  const googleAddtoCalendar = eventCalender?.googleAddtoCalendar;
  const googleImage = eventCalender?.googleImage;
  const enableGoogleCalendar = eventCalender?.enableGoogleCalendar;
  const outlookTitle = eventCalender?.outlookTitle;
  const outlookAddtoCalendar = eventCalender?.outlookAddtoCalendar;
  const outlookImage = eventCalender?.outlookImage;
  const enableOutlookCalendar = eventCalender?.enableOutlookCalendar;

  const getCalendarBtnAction = (e, type) => {
    if (isFixtureCard) {
      if (configData) {
        e.preventDefault();
        if (type === 'Google' && configData?.googleCalendar?.calendarId) {
          handleAuthClick(configData?.googleCalendar?.calendarId);
        } else if (type === 'Apple' && configData?.appleIcs) {
          window.location.href = createDestinationUrl(configData.appleIcs);
        } else if (type === 'Outlook' && configData?.outlookIcs) {
          window.location.href = createDestinationUrl(configData.outlookIcs);
        }
      }
    }
  };
  return (
    <>
      <div className="customMobile">
        <Modal
          containerClass="dialog calender-modal"
          animate={true}
          // containerClass="dialog epg-modal calenderlist-modal"
          customElm={true}
          closeModal={closeModal}
        >
          <div id="modelCustomPop">
            <div className="cd-wrapper">
              <div className="cd-top">
                <div className="icon-modal-logo">
                  <span className="mu-logo"></span>
                </div>
                {calendarTitle && <h2 id="dialogMesg">{calendarTitle}</h2>}
                {Title && <p className="title">{Title} </p>}
                {startdatetime_tdt && (
                  <p>{moment(startdatetime_tdt).format('ddd D MMMM • hh:mm')}</p>
                )}
                {fixtureCalendarHeadline && (
                  <p className="fixtureCalendarHead">{fixtureCalendarHeadline}</p>
                )}
                {isConfigInst && configData?.calendarPrompt && (
                  <div className="calendarPrompt">
                    <p>{configData.calendarPrompt} -&nbsp;</p>
                    {configData?.viewCalendarText && (
                      <a
                        target="_self"
                        href={configData?.viewCalendarUrl ? configData.viewCalendarUrl : '#'}
                      >
                        {configData.viewCalendarText}
                      </a>
                    )}
                  </div>
                )}
                {calendarHeadline && <p className="select-type">{calendarHeadline}</p>}
                {calendarDescription && <p>{calendarDescription}</p>}
              </div>
              <div className="cd-middle">
                <div className="listing-cards">
                  <ul>
                    {enableAppleCalendar && (
                      <li>
                        <div className="outer-contain">
                          <div className="fallbackImg"></div>
                          <ImageFallback
                            src={appleImage}
                            alt=""
                            onErrorClass="no-img"
                            className="img-responsive calender-img"
                            relativePath={false}
                          ></ImageFallback>
                        </div>
                        {appleTittle && <p>{appleTittle}</p>}
                        <div className="red-btn-skew">
                          <a
                            onClick={
                              isFixtureCard
                                ? (e) => getCalendarBtnAction(e, 'Apple')
                                : AddToCalendarButtons(
                                    Title,
                                    startdatetime_tdt,
                                    enddatetime_tdt,
                                    descriptionText(),
                                    'Apple'
                                  )
                            }
                          >
                            {appleAddtoCalendar && (
                              <span className="desktop-text">{appleAddtoCalendar}</span>
                            )}
                            {appleShortAddtoCalendar && (
                              <span className="mobile-text">{appleShortAddtoCalendar}</span>
                            )}
                          </a>
                        </div>
                      </li>
                    )}

                    {enableGoogleCalendar && (
                      <li>
                        <div className="outer-contain">
                          <div className="fallbackImg"></div>
                          <ImageFallback
                            src={googleImage}
                            alt=""
                            onErrorClass="no-img"
                            className="img-responsive calender-img"
                            relativePath={false}
                          ></ImageFallback>
                        </div>
                        {googleTitle && <p>{googleTitle}</p>}
                        <div className="red-btn-skew">
                          <a
                            href={
                              isFixtureCard
                                ? '#'
                                : AddToCalendarButtons(
                                    Title,
                                    startdatetime_tdt,
                                    enddatetime_tdt,
                                    descriptionText(),
                                    'Google'
                                  )
                            }
                            onClick={
                              isFixtureCard ? (e) => getCalendarBtnAction(e, 'Google') : null
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {googleAddtoCalendar && (
                              <span className="desktop-text">{googleAddtoCalendar}</span>
                            )}
                            {googleShortAddtoCalendar && (
                              <span className="mobile-text">{googleShortAddtoCalendar}</span>
                            )}
                          </a>
                        </div>
                      </li>
                    )}
                    {enableOutlookCalendar && (
                      <li>
                        <div className="outer-contain">
                          <div className="fallbackImg"></div>
                          <ImageFallback
                            src={outlookImage}
                            alt=""
                            onErrorClass="no-img"
                            className="img-responsive calender-img"
                            relativePath={false}
                          ></ImageFallback>
                        </div>
                        {outlookTitle && <p>{outlookTitle}</p>}
                        <div className="red-btn-skew">
                          <a
                            onClick={
                              isFixtureCard
                                ? (e) => getCalendarBtnAction(e, 'Outlook')
                                : AddToCalendarButtons(
                                    Title,
                                    startdatetime_tdt,
                                    enddatetime_tdt,
                                    descriptionText(),
                                    'Outlook'
                                  )
                            }
                          >
                            {outlookAddtoCalendar && (
                              <span className="desktop-text">{outlookAddtoCalendar}</span>
                            )}
                            {outlookShortAddtoCalendar && (
                              <span className="mobile-text">{outlookShortAddtoCalendar}</span>
                            )}
                          </a>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
                {noteHeadline && noteDescription && (
                  <p className="note">
                    <b>{noteHeadline}:</b> {noteDescription}
                  </p>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
      {isFixtureCard && configData?.googleCalendar && (
        <Helmet>
          {configData?.googleCalendar?.apiKey && configData?.googleCalendar?.DISCOVERY_DOC && (
            <script
              async
              defer
              src="https://apis.google.com/js/api.js"
              onLoad={gapiLoaded(
                configData?.googleCalendar?.apiKey,
                configData?.googleCalendar?.DISCOVERY_DOC,
                configData?.redirectUrl
              )}
            ></script>
          )}
          {configData?.googleCalendar?.clientId && configData?.googleCalendar?.SCOPES[0] && (
            <script
              async
              defer
              src="https://accounts.google.com/gsi/client"
              onLoad={gisLoaded(
                configData.googleCalendar.clientId,
                configData.googleCalendar.SCOPES[0]
              )}
            ></script>
          )}
        </Helmet>
      )}
    </>
  );
};
CalenderModal.defaultProps = {
  showClose: true,
  successCallback: false,
  isDestinationPage: false,
};
export default withTranslation()(CalenderModal);
